import React from "react";
import SplashScreen from "./components/SplashScreen";
import { useZymedOpenedEvent, ZYMED_EVENTS } from "../../utils/zymedAnalytics";

const TatvaShots: React.FC = () => {
  useZymedOpenedEvent(ZYMED_EVENTS.SHOTS_OPENED);
  return (
    <div className="bg-gray-50 min-h-screen">
      <SplashScreen />
    </div>
  );
};

export default TatvaShots;
